import React, { FC, ReactNode, useMemo } from 'react'

import { createFlowLogger, CreateFlowLoggerParams } from './createFlowLogger'
import { FlowLoggerContext } from './FlowLoggerContext'

type FlowLoggerProviderProps = CreateFlowLoggerParams & {
  children?: ReactNode
}

export const FlowLoggerProvider: FC<FlowLoggerProviderProps> = ({ flowBiSlug, metaSiteId, referralName, children }) => {
  const flowLogger = useMemo(
    () => createFlowLogger({ flowBiSlug, metaSiteId, referralName }),
    [flowBiSlug, metaSiteId, referralName],
  )
  return <FlowLoggerContext.Provider value={flowLogger}>{children}</FlowLoggerContext.Provider>
}
